export const enums_locale = {

  OPERATIONAL_FILE_TYPE: {
    IMPORT: "Import", // 0
    EXPORT: "Export", // 1
    CROSSTRADE: "CrossTrade", // 2
    WHS: "Warehousing (WHS)", // 3
    WIMPORT: "Import + WHS", // 0
    WEXPORT: "Export + WHS", // 1
    WCROSSTRADE: "CrossTrade + WHS"// 2
  },
  TRANSPORT_TYPE: {
    SEA: "Sea", // 0
    AIR: "Air", // 1
    RAIL: "Rail", // 2
    ROAD: "Road"// 3
  },
  TRANSPORT_MODE: {
    AIR: "Air",
    SEA: "Sea",
    BARGE: "Barge",
    BARGETRUCK: "Barge Truck",
    FEEDER: "Feeder",
    RAIL: "Rail",
    ROAD: "Road",
    RAILTRUCK: "Rail Truck",
    TRUCKRAIL: "Truck Rail",
    TRUCK: "Truck",
    VESSEL: "Vessel"
  },
  TRANSPORT_STOP_TYPE: {
    DELIVERY: "Delivery",
    EMPTYDROPOFF: "Empty drop off",
    EMPTYPICKUP: "Empty pickup",
    FULLDELIVERY: "Full delivery",
    FULLPICKUP: "Full pickup",
    PICKUP: "Pick up",
    LOADING: "Loading",
    MULTISTOP: "Multi-stop"
  },
  SHIPMENT_TYPE: {
    FCL: "FCL", // 0
    LCL: "LCL", // 1
    BREAKBULK: "Breakbulk", // 2
    RORO: "RoRo", // 3
    FTL: "FTL", // 4
    LTL: "LTL", // 5
    HAULAGE: "Haulage"// 6
  },
  SUPPLIER_COMUNICATION_TYPE: {
    INTTRA: "INTTRA", // 0
    EDI: "EDI", // 1
  },
  COMMENT_TYPE: {
    TRANSPORT_STOP_COMMENT: "Transport Stop Comment", // 0
    INVOICE_REJECTION_COMMENT: "Invoice Rejection Comment", // 1
    INVOICE_PROTEST_COMMENT: "Invoice Protest Comment", // 2
    QUOTE_REJECTION_COMMENT: "Quote Rejection Comment", // 3
  },
  INVOICE_EXPIRATION_STATUS: {
    ACTIVE: "Active", // 0
    EXPIRED: "Expired", // 1
    EXPIRE_TODAY: "Expire Today", // 2
    EXPIRE_TOMORROW: "Expire Tomorrow",// 3
    REMINDED: "Reminded",
  },
  TENANT_RELATIONS: {
    TITLE: {
      FORDESK_ADMIN: "Fordesk Administrator",
      FORDESK_USER: "Fordesk User",
      CLIENT_PORTAL_USER: "Client Portal User",
      CLIENT_PORTAL_CONFIG: "Client Portal Management",
      MASTERDATA: "Master Data User",
      NOTIFICATIONS: "Notifications User",
      PROSPECTS: "Prospects User",
      TEMPLATES_MGT_ADMIN: "Templates Management User",
      QUOTE_USER: "Quote User",
      REPORTING_USER: "Reporting User",
      USER_MANAGEMENT: "User Management",
      OCR_USER: "OCR User",
      QUOTES_EXTENSION: "Quotes Extension User",

      FINANCE_EXTENSION: "Finance Extension User",
      OUTGOING_FINANCE_ADMIN: "Outgoing Finance Admin",
      INCOMING_FINANCE_ADMIN: "Incoming Finance Admin",
      INCOMING_FINANCE_VIEW: "Incoming Finance View",
    },
    DESCRIPTION: {
      FORDESK_ADMIN: "Allows managing dashboards, currencies, synchronization and integrations",
      FORDESK_USER: "Allows access of users to the Fordesk application",
      CLIENT_PORTAL_USER: "Allows access to the ClientPortal application",
      CLIENT_PORTAL_CONFIG: "Allows managing customers for client portal users",
      MASTERDATA: "Allows access to Masterdata",
      NOTIFICATIONS: "Allows access to notifications",
      PROSPECTS: "Allows access to Sales->Prospects",
      TEMPLATES_MGT_ADMIN: "Allows access to the templates management application",

      FINANCE_EXTENSION: "Allows access to functionality regarding saving unpaid Invoice documents, importing coda files, exporting invoices, creating outgoing invoice documents",
      OUTGOING_FINANCE_ADMIN: "Allows access to outgoing invoices",
      INCOMING_FINANCE_ADMIN: "Allows access to incoming invoices and manage financial information",
      INCOMING_FINANCE_VIEW: "Allows to view and update open incoming invoices and manage attached operationalfiles",

      QUOTE_USER: "Allows access to Sales->Quotes",
      REPORTING_USER: "Allows access to Reporting",
      OCR_USER: "Allows access OCR functionality",
      USER_MANAGEMENT: "Allows management of users",
      QUOTES_EXTENSION: "Allows to see quotes widget"
    }
  },
  VAT_TRANSPORT_TYPE: {
    ANY: "Any",
    INEU_TO_INEU: "In EU to In EU",
    INEU_TO_OUTEU: "In EU to Out EU",
    OUTEU_TO_INEU: "Out EU to In EU",
    OUTEU_TO_OUTEU: "Out EU to Out EU",
  },
  VAT_CUSTOMER_TYPE: {
    ANY: "Any",
    BE: "BE",
    EU: "EU",
    NONEU: "Non EU",
    EU_EXCEPTION: "EU Exception",
    NONEU_EXCEPTION: "Non EU Exception",
  },
};

